import React from 'react';

import CardDialog from '~/components/CardDialog';
import ConfigurationScreenWithTabs from '~/components/SystemConfiguration/ConfigurationScreenWithTabs';
import OperationsBreadcrumbs from '~/components/SystemConfiguration/OperationsBreadcrumbs';
import { ADMIN_ROUTES } from '~/routesConstants';

import ESignConfigurationTab from './ESignConfigurationTab';

const E_SIGN_CONFIGURATION_SUBTITLE = 'Configure electronic signature integration settings with Dropbox Sign.';

const ESignConfiguration: React.FC = () => {
  const tabs = [
    {
      label: 'Configuration',
      url: ADMIN_ROUTES.E_SIGN_CONFIGURATION.MAIN,
      component: ESignConfigurationTab,
      isEnabled: true,
    },
  ];

  return (
    <CardDialog noCardTitle>
      <OperationsBreadcrumbs currentTab="E-Sign Configuration" />
      <ConfigurationScreenWithTabs
        tabs={tabs}
        title="E-SIGN CONFIGURATION"
        subtitle={E_SIGN_CONFIGURATION_SUBTITLE}
        operationTabName="E-Sign Configuration"
      />
    </CardDialog>
  );
};

export default ESignConfiguration;
